// List of features.
module.exports = {
  // Monitor
  OXIGEN_BY_PATIENT: 'oxigen_by_patient',
  UPDATE_RESTITUTION: 'update_restitution',
  UPDATE_PRESCRIPTION: 'update_prescription',
  // Delivery
  SAVE_PENDING_DELIVERY: 'save_pending_delivery',
  LIST_PENDING_DELIVERY: 'list_pending_delivery',
  LIST_CONFIRM_DELIVERY: 'list_confirm_delivery',
  CONFIRM_PENDING_DELIVERY: 'confirm_pending_delivery',
  LIST_EDIT_CONFIRM_DELIVERY: 'list_edit_confirm_delivery',
  SAVE_EDIT_CONFIRM_DELIVERY: 'save_edit_confirm_delivery',
  // Client
  LIST_CLIENT: 'list_client',
  VIEW_CLIENT: 'view_client',
  CREATE_CLIENT: 'create_client',
  UPDATE_CLIENT: 'update_client',
  REMOVE_CLIENT: 'remove_client',
  // Users
  LIST_ACCOUNT: 'list_account',
  VIEW_ACCOUNT: 'view_account',
  CREATE_ACCOUNT: 'create_account',
  UPDATE_ACCOUNT: 'update_account',
  REMOVE_ACCOUNT: 'remove_account',
  // Patient
  LIST_PATIENT: 'list_patient',
  VIEW_PATIENT: 'view_patient',
  CREATE_PATIENT: 'create_patient',
  UPDATE_PATIENT: 'update_patient',
  REMOVE_PATIENT: 'remove_patient',
  INITIALIZE_PATIENT: 'init_patient',
  DEACTIVATE_PATIENT: 'deinit_patient',
  // Device
  LIST_DEVICE: 'list_device',
  VIEW_DEVICE: 'view_device',
  CREATE_DEVICE: 'create_device',
  UPDATE_DEVICE: 'update_device',
  REMOVE_DEVICE: 'remove_device',
  // Supplier
  LIST_SUPPLIER: 'list_supplier',
  VIEW_SUPPLIER: 'view_supplier',
  CREATE_SUPPLIER: 'create_supplier',
  UPDATE_SUPPLIER: 'update_supplier',
  REMOVE_SUPPLIER: 'remove_supplier',
  // Report
  OXIGEN_USAGE_REPORT: 'oxigen_usage_report',
  // Cylinder
  LIST_CYLINDER: 'list_cylinder'
};